import {
  useAmplitude,
  useCustomerIO,
  useGleap,
  useMixpanel,
  usePostHog,
} from '@aibees/shared/hooks';
import { MixpanelEvent } from '../types';

export function useTrackEvents() {
  const { track: mixPanelTrack } = useMixpanel<MixpanelEvent>();
  const { track: amplitudeTrack } = useAmplitude<MixpanelEvent>();
  const { track: gleapTrack } = useGleap<MixpanelEvent>();
  const { track: customerIOTrack } = useCustomerIO<MixpanelEvent>();
  const { track: posthogTrack } = usePostHog<MixpanelEvent>();

  const track = async (event: MixpanelEvent, data: Record<string, any>) => {
    mixPanelTrack(event, data);
    amplitudeTrack(event, data);
    gleapTrack(event, data);
    posthogTrack(event, data);
    customerIOTrack?.(event, data);
  };

  return { track };
}
